<template>
  <div class="social-media">
    <span
      v-for="(social, index) in urls"
      :class="[`social-media__container--${social.type}`]"
      :key="index"
    >
      <a
        class="social-media__link social-media__link--pinterest"
        v-if="social.type === 'pinterest'"
        :href="`${social.url}?url=${productStore.productDetails.product.productUrl}`"
        target="_blank"
        rel="nofollow noopener"
        aria-label="pinterest link"
      >
        <span
          class="social-media__link-text"
          v-if="social.name && showSocialName"
        >
          {{ social.name }}
        </span>
      </a>
      <a
        class="social-media__link social-media__link--facebook"
        v-if="social.type === 'facebook'"
        :href="`${social.url}?u=${productStore.productDetails.product.productUrl}`"
        target="_blank"
        rel="nofollow noopener"
        aria-label="facebook link"
      >
        <span
          class="social-media__link-text"
          v-if="social.name && showSocialName"
        >
          {{ social.name }}
        </span>
      </a>
      <a
        class="social-media__link social-media__link--twitter"
        v-if="social.type === 'twitter'"
        :href="`${social.url}?url=${productStore.productDetails.product.productUrl}`"
        target="_blank"
        rel="nofollow noopener"
        aria-label="twitter link"
      >
        <span
          class="social-media__link-text"
          v-if="social.name && showSocialName"
        >
          {{ social.name }}
        </span>
      </a>
      <a
        class="social-media__link social-media__link--mail"
        v-if="social.type === 'mail'"
        :href="`${social.url}%20${productStore.productDetails.product.productUrl}`"
        rel="nofollow noopener"
        target="_blank"
        aria-label="mail link"
      >
        <span
          class="social-media__link-text"
          v-if="social.name && showSocialName"
        >
          {{ social.name }}
        </span>
      </a>
      <a
        class="social-media__link social-media__link--whatsapp"
        v-if="social.type === 'whatsapp'"
        :href="`${social.url}%20${productStore.productDetails.product.productUrl}`"
        rel="nofollow noopener"
        target="_blank"
        aria-label="whatsapp link"
      >
        <span
          class="social-media__link-text"
          v-if="social.name && showSocialName"
        >
          {{ social.name }}
        </span>
      </a>
      <a
        class="social-media__link social-media__link--instagram"
        v-if="social.type === 'instagram'"
        :href="social.url"
        target="_blank"
        rel="nofollow noopener"
        aria-label="instagram link"
      >
        <span
          class="social-media__link-text"
          v-if="social.name && showSocialName"
        >
          {{ social.name }}
        </span>
      </a>
    </span>
  </div>
</template>

<script lang="ts">
  import {Options, Prop, Vue} from 'vue-property-decorator';
  import productStore, {ProductStore} from '../../stores/product/ProductStore';

  @Options({
    name: 'product-social-media',
  })
  export default class SocialMedia extends Vue {

    @Prop()
    urls: any[];

    @Prop({default: false})
    showSocialName: boolean;

    productStore: ProductStore = productStore;

  }
</script>
